import Image from 'next/image';

import { Text } from '@northladder/i18n';

import { IDeviceImageOptionsWithMetadataTranslations } from '../../types';

import { ImageUploadStatusBadge } from './ImageUploadStatusBadge';

type TImageUploadIItemProps = Pick<
  IDeviceImageOptionsWithMetadataTranslations,
  'title' | 'titlePostfix' | 'imageData'
>;

/**
 * -----------------------------------------------------------------------------
 * Creates functionality for selecting, uploading and previewing the uploaded
 * image.
 */
export function DeviceImageUploadWithFile({
  imageData,
  // subTitle,
  title,
  titlePostfix,
}: TImageUploadIItemProps) {
  const { croppedImgSrc, status } = imageData;

  return (
    <div
      className="
        group relative flex flex-col overflow-hidden rounded-lg border
         border-gray-200 bg-white hover:shadow-lg hover:shadow-gray-200/50
      "
    >
      <div
        className="
          aspect-w-3 aspect-h-4 sm:aspect-none bg-gray-200
          group-hover:opacity-75 sm:h-96
          "
      >
        <Image
          alt="Front Image"
          className="h-full w-full object-contain object-center sm:h-full sm:w-full"
          height={1200}
          src={croppedImgSrc}
          width={600}
        />
        <ImageUploadStatusBadge status={status} />
      </div>
      <div
        className="
          group-hover:text-primary-500 group-focus:text-primary-400 w-full flex-col px-4 py-2
          text-sm text-gray-400
        "
      >
        <p
          className="
              group-hover:text-primary-500 group-focus:text-primary-400 flex w-full
              flex-col items-start pb-1 pt-2 text-sm text-gray-600
            "
        >
          {title ? (
            <span>
              <Text text={title} />
            </span>
          ) : null}

          {titlePostfix ? (
            <span className="text-xs font-light">
              <Text text={titlePostfix} />
            </span>
          ) : null}
        </p>

        {/* <span
          className="
              flex  w-full flex-col text-start text-xs font-light
              text-gray-400 group-hover:text-primary-500 group-focus:text-primary-400
            "
        >
          {subTitle ? (
            <span className="py-1">
              <Text text={subTitle} />
            </span>
          ) : null}
        </span> */}
      </div>
    </div>
  );
}
